"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var LoadingBackDrop = function (props) {
    var theme = (0, material_1.useTheme)();
    return (react_1.default.createElement(material_1.Backdrop, { open: props.open, className: "loading", sx: { zIndex: theme.zIndex.drawer + 1 } },
        react_1.default.createElement(material_1.CircularProgress, null)));
};
exports.default = LoadingBackDrop;
